/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RefundStatusEnum = 'WaitingForApproval' | 'Approved' | 'Declined' | 'Processed' | 'Cancelled' | 'Failed' | 'BeingProcessed';

export const RefundStatusEnum = {
    WaitingForApproval: 'WaitingForApproval' as RefundStatusEnum,
    Approved: 'Approved' as RefundStatusEnum,
    Declined: 'Declined' as RefundStatusEnum,
    Processed: 'Processed' as RefundStatusEnum,
    Cancelled: 'Cancelled' as RefundStatusEnum,
    Failed: 'Failed' as RefundStatusEnum,
    BeingProcessed: 'BeingProcessed' as RefundStatusEnum
};

